var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23 41L1.5 21L23 1","stroke":"#303030","strokeWidth":"1.4"}));
}

ArrowLeft.defaultProps = {"width":"24","height":"42","viewBox":"0 0 24 42","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
